import { ActionTypes } from '../../enums/action-types';
import { ObjectTypeEnum } from '../../enums/object-types';
import { Location } from '../../models';

export interface EditTransportServiceRequest {
  id: string;
  objectType: ObjectTypeEnum;
  action: ActionTypes;
  size: string;
  weight: number;
  locationId: Location;
  createdAt?: string;
  LC_Code?: string;
  product?: string;
  tripInfo?: string;
  Description?: string;
  jobNumber: string;
  planId: string;
  systemLocationId?: string;
}
